import type { RoomTypeTotal } from '../../lib/api.js';
import { fmtInt, fmtPct } from '../../lib/format.js';
import { CANAL_COLORS } from './ChartCard.js';

/**
 * Tipos de habitación que vende Expedia, de mayor a menor.
 *
 * Barras horizontales y no verticales porque los nombres son largos («Classic
 * Double Room, 2 Queen Beds, City View»): en vertical habría que girarlos o
 * recortarlos. Una sola serie, así que no lleva leyenda — el título la nombra —
 * y cada barra va rotulada con su cifra, que es la vista tabular accesible.
 *
 * Todas comparten el color del canal: aquí la magnitud la codifica el LARGO, no
 * el tono; dar un color por tipo inventaría una identidad que no existe.
 */
export function ExpediaRoomTypes({ rows }: { rows: RoomTypeTotal[] }) {
  const conNoches = rows.filter((r) => r.noches > 0);
  if (conNoches.length === 0) {
    return <p className="text-sm text-slate-500">Sin noches de Expedia en el período.</p>;
  }
  const max = Math.max(...conNoches.map((r) => r.noches));

  return (
    <ul className="space-y-2.5">
      {conNoches.map((r) => (
        <li key={r.roomType}>
          <div className="flex items-baseline justify-between gap-3 text-xs">
            <span className="min-w-0 truncate text-slate-300" title={r.roomType}>
              {r.roomType}
            </span>
            <span className="shrink-0 tabular-nums text-slate-400">
              <span className="font-medium text-slate-100">{fmtInt(r.noches)}</span> noches
              {r.share != null && (
                <span className="ml-1 text-slate-500">{fmtPct(r.share * 100)}</span>
              )}
            </span>
          </div>
          <div className="mt-1 flex items-center gap-2">
            <div
              className="h-2.5 rounded-sm"
              style={{ width: `${(r.noches / max) * 100}%`, backgroundColor: CANAL_COLORS.EXP }}
            />
            <span className="shrink-0 text-[11px] tabular-nums text-slate-500">
              {fmtInt(r.reservas)} res.
              {r.canceladas > 0 && ` · ${fmtInt(r.canceladas)} canc.`}
            </span>
          </div>
        </li>
      ))}
    </ul>
  );
}
